import {
	OrbitControls
} from 'three/examples/jsm/controls/OrbitControls';
import * as THREE2 from 'three';

export const LoadThree = {
	data() {
		return {
			func: null,
			renderer: null,
			scene: null,
			camera: null,
			control: null,
			lightList: [{
				type: 'point', //  ambient/point
				color: '0xffffff',
				intensity: 1, // 光的强度
				distance: 0, // 光照距离，默认为0，表示无穷远都能照到.
				decay: 1, // 随着光的距离，强度衰减的程度，默认为1，为模拟真实效果，建议设置为2
				position: [400, 1000, 300]
			}, {
				type: 'point',
				color: '0xffffff',
				intensity: 1, // 光的强度
				distance: 0, // 光照距离，默认为0，表示无穷远都能照到.
				decay: 1, // 随着光的距离，强度衰减的程度，默认为1，为模拟真实效果，建议设置为2
				position: [-400, -1000, -300]
			}]
		}
	},
	methods: {
		loadThree(dom, func) {
			let scene = new THREE.Scene();
			this.scene = scene;

			let width = dom.clientWidth;
			let height = dom.clientHeight;
			let k = width / height;
			let s = 40;
			// let camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 4000);

			let camera = new THREE.PerspectiveCamera(40, k, 1, 4000);
			this.camera = camera;
			this.camera.position.set(250, 100, -100);
			// this.camera.position.set(200, 3000, 200);
			this.camera.lookAt(this.scene.position);
			let renderer = new THREE.WebGLRenderer({
				antialias: true
			});
			this.renderer = renderer;
			this.loadLight();
			let ambient = new THREE.AmbientLight(0x444444);
			this.scene.add(ambient);
			this.renderer.setSize(width, height);
			this.renderer.setClearColor(0xb9d3ff, 1);
			dom.appendChild(this.renderer.domElement);
			this.control = new OrbitControls(this.camera, this.renderer.domElement);
			this.control.enableDamping = true; // 添加阻尼效果,必须在动画循环里添加update
			// this.control.enablePan = false; // 禁止平移
			this.control.panSpeed = 0.1;
			this.control.enableZoom = true; // 禁止缩放
			this.control.maxPolarAngle = Math.PI / 2.1; // 垂直旋转的角度的上限
			this.control.maxZoom = 2
			this.control.minZoom = 0.5
			this.control.maxDistance = 200
			this.control.minDistance = 75
			if (typeof func == 'function' && func)
				this.func = func
			else this.func = null
			this.render();
			this.windowResize(dom)
		},
		loadLight(lightList) {
			this.lightList = Object.assign([], this.lightList, lightList);
			this.lightList & this.lightList.forEach((light) => {
				let l
				if (light.type === 'point') {
					l = new THREE.PointLight(light.color, light.intensity, light.distance, light.decay);
					l.position.set(...light.position);
				} else if (light.type === 'ambient') {
					l = new THREE.AmbientLight(light.color, light.intensity);
					l.position.set(...light.position);
				}
				this.scene.add(l);
			});
		},
		windowResize(dom) {
			window.addEventListener('resize', () => {
				// 更新摄像头
				this.camera.aspect = dom.clientWidth / dom.clientHeight;
				// 更新摄像头的投影矩阵
				this.camera.updateProjectionMatrix();
				// 更新渲染器
				this.renderer.setSize(dom.clientWidth, dom.clientHeight)
				//设置渲染器的像素比
				this.renderer.setPixelRatio()
			})
		},
		render() {
			this.renderer.render(this.scene, this.camera);
			this.renderer.sortObjects = false;
			this.control.update();
			if (this.func)
				this.func()
			requestAnimationFrame(this.render);
		}
	},
}
